<template>
  <v-contain>
    <v-card class="masterCard">
      <v-card-title>
        <v-autocomplete
          :items="AuxTypes"
          v-model="AuxType"
          label="Seleccione el tipo de auxiliar"
          @change="updateSelections"
        ></v-autocomplete>
      </v-card-title>

      <Auxiliar :Auxiliares="selectedAux" :auxType="AuxType" />
    </v-card>
  </v-contain>
</template>

<script>
import Auxiliar from "@/components/AuxiliarComponent.vue";
import { getAllAuxiliar } from "@/utils/apiRequest.js";
export default {
  data() {
    return {
      Auxiliares: [""],
      AuxTypes: [""],
      AuxType: "",
      selectedAux: [],
      questions: [],
    };
  },
  components: {
    Auxiliar,
  },
  methods: {
    updateSelections() {
      let tempTypes = [];
      this.Auxiliares.forEach((aux) => {
        if (aux.type == this.AuxType || this.AuxType == "") {
          tempTypes.push(aux);
        }
      });
      this.selectedAux = tempTypes;
    },
  },
  async mounted() {
    let response = await getAllAuxiliar();
    let ql = [];
    if (response.data) {
      if (response.data.status == "success") {
        this.Auxiliares = response.data.auxiliar;
        this.Auxiliares.forEach((aux) => {
          ql.push(aux.type);
        });
        this.selectedAux = this.Auxiliares;
        this.AuxTypes = ql.sort();
      }
    }
  },
};
</script>

<style scoped>
.flex {
  align-items: center;
  align-content: center;
  align-self: center;
}
.masterCard {
  align-self: center;
  margin: 0 auto;
  min-height: 100%
}
</style>